import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import "./ContactReminderBanner.css";

/**
 * ContactReminderBanner component to remind users to add their contact number
 * @param {Object} props - Component props
 * @param {Function} props.setCurrentView - Function to set the current view
 * @returns {JSX.Element} - Rendered component
 */
const ContactReminderBanner = ({ setCurrentView }) => {
  return (
    <div className="contact-reminder-banner">
      <FaPhoneAlt className="banner-icon" />
      <div className="banner-content">
        <p>Please add your contact number.</p>
        <button
          onClick={() => setCurrentView("profile")}
          className="add-contact-button"
        >
          Add Contact Number
        </button>
      </div>
    </div>
  );
};

export default ContactReminderBanner;
